import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import DashboardContent from './components/DashboardContent'

const Dashboard: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <DashboardContent />
      <Footer />
    </>
  )
}

export default Dashboard
